import { ChevronLeft, ChevronRight } from 'lucide-react';
import type { ReactElement } from 'react';

const CONTROL_CLASS =
  'flex size-10 items-center justify-center rounded-full border border-foreground/15 transition-colors hover:bg-muted disabled:cursor-not-allowed disabled:opacity-40 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring';

interface PortfolioCarouselControlsProps {
  readonly canScrollPrev: boolean;
  readonly canScrollNext: boolean;
  readonly onPrev: () => void;
  readonly onNext: () => void;
}

/**
 * 수동 캐러셀 조작 — 이전, 다음.
 * 이전·다음은 끌기를 못 하는 키보드·단일 포인터 사용자도 넘길 수 있게 한다(WCAG 2.5.7).
 */
export const PortfolioCarouselControls = ({
  canScrollPrev,
  canScrollNext,
  onPrev,
  onNext,
}: PortfolioCarouselControlsProps): ReactElement => (
  <div className="mt-10 flex justify-end gap-2 sm:mt-12">
    <button
      type="button"
      onClick={onPrev}
      disabled={!canScrollPrev}
      aria-label="이전 포트폴리오"
      className={CONTROL_CLASS}
    >
      <ChevronLeft aria-hidden className="size-4" />
    </button>
    <button
      type="button"
      onClick={onNext}
      disabled={!canScrollNext}
      aria-label="다음 포트폴리오"
      className={CONTROL_CLASS}
    >
      <ChevronRight aria-hidden className="size-4" />
    </button>
  </div>
);
